import type { ExternalTableSchema } from '@packages/table-builder';

export const participantServiceTable: ExternalTableSchema = {
  metadata: {
    title: 'Participant Service',
    entity: 'ParticipantService',
    description:
      'Cross-company participant lookup for operations staff. Results load only after filters are applied.',
  },

  dataSource: {
    endpoint: '/api/customer/api/app/participant-service/search',
    method: 'POST',
    rowIdField: 'participantId',
    fetchPolicy: 'requireFilter',
    responseMapping: {
      items: 'items',
      totalCount: 'totalCount',
    },
    requestParams: {
      skipCount: 'table.pageOffset',
      maxResultCount: 'table.pageSize',
      sorting: 'table.sorting',
      companyId: 'filters.companyId',
      firstName: 'filters.firstName',
      middleName: 'filters.middleName',
      lastName: 'filters.lastName',
      employeeId: 'filters.employeeId',
      email: 'filters.email',
    },
    filters: [
      {
        name: 'companyId',
        placeholder: 'Company',
        type: 'asyncSelect',
        dataSource: {
          url: '/api/customer/api/app/participant-service/companies',
          labelField: 'companyName',
          valueField: 'companyId',
        },
      },
      {
        name: 'firstName',
        placeholder: 'First Name',
        type: 'text',
      },
      {
        name: 'middleName',
        placeholder: 'Middle Name',
        type: 'text',
      },
      {
        name: 'lastName',
        placeholder: 'Last Name',
        type: 'text',
      },
      {
        name: 'employeeId',
        placeholder: 'Employee ID',
        type: 'text',
      },
      {
        name: 'email',
        placeholder: 'Email',
        type: 'text',
      },
    ],
  },

  columns: [
    {
      field: 'companyName',
      header: 'Company',
      sortable: true,
      width: 200,
      visibility: 'locked',
    },
    {
      field: 'fullName',
      header: 'Participant Details',
      type: 'couple',
      sortable: true,
      width: 200,
      couple: {
        titleField: 'fullName',
        subtitleField: 'employeeId',
        showTag: true,
      },
    },
    {
      field: 'participantType',
      header: 'Type',
      type: 'badge',
      sortable: true,
      width: 120,
      align: 'center',
      badge: {
        statusMap: { Individual: 'info', Entity: 'success', 1: 'info', 2: 'success' },
        defaultVariant: 'default',
      },
      conditionalValues: { 1: 'Individual', 2: 'Entity' },
    },
    {
      field: 'email',
      header: 'Email',
      sortable: true,
      width: 220,
    },
  ],

  actions: {
    row: [
      {
        id: 'PARTICIPANT_SERVICE_VIEW_READONLY',
        label: 'Participant View (Readonly)',
        semanticId: 'participantViewReadOnlyAction',
      },
      {
        id: 'PARTICIPANT_SERVICE_VIEW_READWRITE',
        label: 'Participant View (Read-write)',
        semanticId: 'participantViewReadWriteAction',
      },
    ],
  },

  features: {
    emptyFilterMessage: 'Set filters and click Search to view participants.',
    search: { enabled: false },
    defaultSort: { field: 'fullName', direction: 'asc' },
    pagination: { mode: 'infiniteScroll', defaultSize: 50 },
    columnPreferences: {
      persistenceKey: 'ParticipantService',
      resizable: true,
      reorderable: true,
    },
  },
};
